import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { EmployeesArchiveHead } from "../EmployeesArchive/EmployeesArchiveHead";
import { EmployeesArchiveTable } from "../EmployeesArchive/EmployeesArchiveTable";

export function EmployeesArchive() {
  return (
    <Container>
      <Row>
        <Col>
          <EmployeesArchiveHead />
        </Col>
      </Row>
      <Row>
        <Col>
          <EmployeesArchiveTable />
        </Col>
      </Row>
    </Container>
  );
}
